import { IGenericObject } from '../typings/common-types';

/**
 * Utility function to check valid model
 * @param model
 */
export const validateModel = (model: unknown): IGenericObject => {
  if (typeof model === 'object') {
    return model as IGenericObject;
  } else if (typeof model === 'string') {
    return JSON.parse(model);
  } else {
    return {};
  }
};

export const isEmptyObject = (object: IGenericObject) => !Object.keys(object).length;

export const isValidObject = (object: IGenericObject) => object && !isEmptyObject(object);
